

import React from "react";
import { Box, Typography, ThemeProvider, Button } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const HeroSection = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
  },
}));

const HeroContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 2,
  color: "white",
  padding: theme.spacing(4),
  textAlign: "left",
  maxWidth: "600px",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontFamily: "Helvetica Neue",
  marginBottom: theme.spacing(0.5),
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
  [theme.breakpoints.down("md")]: {
    fontSize: "2.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const LearnMoreButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#AB052D",
  color: "white",
  borderRadius: "50%",
  minWidth: "32px",
  height: "32px",
  padding: 0,
  marginTop: theme.spacing(1),
  transition: "background-color 0.3s, color 0.3s",
  "&:hover": {
    backgroundColor: "white",
    "& .MuiSvgIcon-root": {
      color: "#AB052D",
      transform: "scale(1.2)",
      transition: "transform 0.3s",
    },
  },
  [theme.breakpoints.down("md")]: {
    minWidth: "32px",
    height: "32px",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "28px",
    height: "28px",
  },
}));

// Function to handle smooth scroll to HistorySection
const handleLearnMoreClick = () => {
  const historySection = document.getElementById("blog-section");
  if (historySection) {
    historySection.scrollIntoView({ behavior: "smooth" });
  }
};

export default function BlogHeroSection() {
  const theme = useTheme();
  const lines = ["Our", "Blogs"];

  return (
    <ThemeProvider theme={theme}>
      <HeroSection
      >

        
        <Box
          component="img"
          src="/assets/image/blog_bg.png"
          alt="Award Background"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: { xs: "38% center", sm: "center" }, // Moves left on mobile

            zIndex: -1,
          }}
        />

        <HeroContent sx={{ position: "absolute", left: "5%", top: "60%", transform: "translateY(-50%)" }}>
          {lines.map((line, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: index * 0.5 }}
            >
              <HeroTitle variant="h3">{line}</HeroTitle>
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: lines.length * 0.5 }}
            style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "16px" }}
          >
            <LearnMoreButton aria-label="Learn More" onClick={handleLearnMoreClick}>
              <ChevronRightIcon />
            </LearnMoreButton>
            <Typography
              variant="h6"
              onClick={handleLearnMoreClick}
              sx={{
                color: "white",
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: 200,
                fontFamily: '"Inter", "Arial", sans-serif',
                pt: 1,
              }}
            >
              Learn More
            </Typography>
          </motion.div>
        </HeroContent>
      </HeroSection>
    </ThemeProvider>
  );
}